import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';


const checklistStatus = [
  {
    value: true,
    label: 'Completed'
  },
  {
    value: false,
    label: 'Not Completed'
  },
];

const openStatus = [
  {
    value: 'no',
    label: 'No'
  },
  {
    value: 'yes',
    label: 'Yes'
  },
];

const fraudOptions = [
  {
    value: 'no',
    label: 'No'
  },
  {
    value: 'yes',
    label: 'Yes'
  },
];

const offerTypes = [
  {
    value: 'buy',
    label: 'Buy'
  },
  {
    value: 'sell',
    label: 'Sell'
  },
];


const split = [
  {
    value: 1,
    label: '1 - (2 traders)'
  },
  {
    value: 2,
    label: '2 - (2 traders)'
  },
  {
    value: 'a',
    label: 'A - (3 traders)'
  },
  {
    value: 'b',
    label: 'B - (3 traders)'
  },
  {
    value: 'c',
    label: 'C - (3 traders)'
  },
];

class TradeFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
      context,
    } = this.props;

    return (
      <div className="filters-container admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Split:</label>
            <Select name="split" options={split} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Type:</label>
            <Select name="type" options={enums.giftcards} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Status:</label>
            <Select name="status" options={enums.tradeStatus} selectLabel="-" emptyOption/>
          </FormGroup>
          {context !== 'open' && (
            <FormGroup>
              <label>Is Open:</label>
              <Select name="openStatus" options={openStatus} selectLabel="-" emptyOption/>
            </FormGroup>
          )}
          <FormGroup>
            <label>Is Fraud:</label>
            <Select name="fraud" options={fraudOptions} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Checklist:</label>
            <Select name="checklistStatus" options={checklistStatus} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Date:</label>
            <Input name="date" type="date" placeholder="YYYY-MM-DD"/>
          </FormGroup>
          <FormGroup>
            <label>Trade Id:</label>
            <Input name="tradeId" type="text"/>
          </FormGroup>
          <FormGroup>
            <label>Message:</label>
            <Input name="messages" type="text"/>
          </FormGroup>
          <FormGroup>
            <label>Offer:</label>
            <Select name="offer_type" options={offerTypes} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Currency:</label>
            <Select name="fiat_currency_code" options={enums.currencies} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Multi</label>
            <Input name="allowMultiExpand" type="checkbox"/>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default TradeFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeFilters/TradeFilters.view.js